var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.which,{tag:"component",attrs:{"level":_vm.level,"visible":_vm.visible,"edit-rows":_vm.editRows},on:{"close-drawer":_vm.closeDrawer,"refresh":_vm.refreshList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }